<template>

    <v-panel class="maxw-600">
        <template #title>Change Password</template>
        <template #body>
            <v-alert :message="error" />
            <form @submit.prevent="submit">
                <v-form-group dir="ver" label="New Password">
                    <v-input type="password" :model="params.password" @input="params.password = $event" />
                </v-form-group>
                <v-form-group class="mb-30" dir="ver" label="Confirm Password">
                    <v-input type="password" :model="params.password_confirmation" @input="params.password_confirmation = $event" />
                </v-form-group>
                <v-button btn-type="submit" :loading="loading" @click.native="submit" btn-block>Update Password</v-button>
            </form>
        </template>
    </v-panel>

</template>

<script>

import AuthApi from '@api/AuthApi';

export default {

    data() {
        return {
            loading: false,
            error: null,
            params: {
                temp_token: this.$route.params.temp_token,
            },
        }
    },

    mounted() {
        // Show Recaptcha
        if (this.$recaptchaInstance) {
            this.$recaptchaInstance.showBadge();
        }
        window.addEventListener('load', () => {
            this.$recaptchaInstance.showBadge();
        });
    },

    beforeDestroy() {
        if (this.$recaptchaInstance) {
            this.$recaptchaInstance.hideBadge();
        }
    },

    methods: {

        async submit() {
            if (this.loading) return;
            this.loading = true;
            await this.$recaptchaLoaded();
            this.params.recaptcha = await this.$recaptcha('password/change');
            AuthApi.changePassword(this.params)
                .then((response) => {
                    this.loading = false;
                    this.error = null;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$router.push({ name: 'login' });
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

    }

}

</script>
